import React, { useEffect, useState } from "react";
import GlobalStyles, { CommonClasses } from "../../global/GlobalStyles";
import { FaBoxOpen, FaClock, FaShippingFast, FaTruck } from "react-icons/fa";
import api from "../../global/api";
import toast from "react-hot-toast";

const DashboardStatistics = () => {
  const [statistics, setStatistics] = useState({
    total_shipments: 0,
    total_delivered: 0,
    total_pending: 0,
    total_in_transit: 0,
  });

  const stats = [
    {
      id: "total_shipments",
      name: "Total Shipments",
      count: statistics.total_shipments,
      icon: <FaTruck className="text-primary" />,
    },
    {
      id: "total_delivered",
      name: "Delivered",
      count: statistics.total_delivered,
      icon: <FaBoxOpen className="text-green-500" />,
    },
    {
      id: "total_pending",
      name: "Pending",
      count: statistics.total_pending,
      icon: <FaClock className="text-yellow-500" />,
    },
    {
      id: "total_in_transit",
      name: "In Transit",
      count: statistics.total_in_transit,
      icon: <FaShippingFast className="text-blue-500" />,
    },
  ];

  const fetchStatistics = async () => {
    try {
      const { data } = await api.get("/statistics");
      setStatistics(data.data);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to load statistics");
      setStatistics({
        total_shipments: 0,
        total_delivered: 0,
        total_pending: 0,
        total_in_transit: 0,
      });
    }
  };

  useEffect(() => {
    fetchStatistics();
  }, []);

  return (
    <div className={GlobalStyles.sectionDividerGridFour}>
      {stats.map((item) => (
        <div
          key={item.id}
          className={`${GlobalStyles.sectionWrap} ${CommonClasses.transition}`}
        >
          <div className="w-full flex items-center justify-between">
            <span className="text-4xl">{item.icon}</span>
            <div className="flex flex-col items-end">
              <h3 className="capitalize text-sm font-semibold text-secondary">
                {item.name}
              </h3>
              <p
                className={`text-2xl font-bold text-dark dark:text-light ${CommonClasses.transition}`}
              >
                {item.count}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStatistics;
